import {oneOf} from '@/utils/utils'
import config from '@/config'
export default {
  inserted(el, binding) {
    const verifyCode = binding.value
    const verifyCodeList = JSON.parse(sessionStorage.getItem(config.verifyCodeName)) || []
    if (verifyCode && !oneOf(verifyCode, verifyCodeList)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}